import React from "react";
import { useTheme } from "@fluentui/react";
// Styles
import { getClassNames, getStyles } from "./SuiteNav.styles";
/**
 * Suite nav place holder while loading lazy loaded suite nav container
 */ export const SuiteNavLoadingPlaceHolder = ()=>{
    const theme = useTheme();
    const suiteNavClassNames = getClassNames(getStyles(theme));
    return /*#__PURE__*/ React.createElement("div", {
        className: suiteNavClassNames.suiteNavPlaceHolder
    });
};
